import styled, { withTheme } from 'styled-components'
import { rem } from 'polished'
import { Box, Text } from 'rebass'
import media, { Grid } from '../../../utils/style'
import IconAccountProfile from '../../../vectors/IconAccountProfile'
import typography from '../../../utils/typography'

const SubMenu = withTheme(styled.div`
  position: relative;
  z-index: 3;
  white-space: nowrap;
`)

const Menu = withTheme(styled.div`
  position: absolute;
  z-index: 3;
  top: 100%;
  right: 0;
  background: white;
  border-top: 5px ${(props) => props.theme.colors.blue} solid;
  box-shadow: -2px 25px 81px 2.3px rgba(102, 102, 102, 0.25),
    1px 4px 8px 0 rgba(0, 0, 0, 0.15);
  > a {
    text-decoration: none;
    text-transform: uppercase;
    font-size: ${rem('13px')};
    font-weight: 600;
    color: ${(props) => props.theme.colors.grey_light};
    display: block;
    padding: ${typography.rhythm(0.45)} 32px ${typography.rhythm(0.45)} 15px;
    line-height: 1;
    transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo};
    border-bottom: 1px rgba(154, 163, 179, 0.15) solid;
  }

  .profile {
    path {
      fill: black;
    }
  }

  > a.active {
    opacity: 1;
    color: ${(props) => props.theme.colors.blue};
  }

  > a:hover {
    a {
      will-change: color, opacity;
    }
  }

  > a:last-child {
    border-bottom: none;
  }
`)

/*************************
  STYLES: Drop-down
**************************/

const navigationlinkStyle = `
    text-decoration: none;
    text-transform: uppercase;
    font-size: ${rem('14.5px')};
    font-weight: 600;
    letter-spacing: 0.12em;

    display: block;
    &:hover {
      opacity: 1;
    }
  }`

const AccountDropDown = styled(Grid)`
  padding: 14px 8px 12px 10px;
  vertical-align: baseline;
  position: relative;
  z-index: 0;
  width: 56px;

  .arrow {
    position: relative;
    margin-left: 7px;
    top: -5px;
  }

  .account__menu {
    pointer-events: none;
    transition: transform 0.4s ${(props) => props.theme.ease.ease_out_expo},
      opacity 0.2s ${(props) => props.theme.ease.ease_out_expo};
    transform: scale(1.02) translate3d(0, ${rem(0)}, 0);
    ${media.LargeScreenUp`
    transform: scale(1.02) translate3d(0, ${rem(10)}, 0);
    `}
    opacity: 0;
    width: 56px;
  }

  &:focus .account__menu {
    opacity: 1;
  }

  &.open {
    .account__menu {
      display: block;
      opacity: 1;
      pointer-events: auto;
      transform: scale(1) translate3d(0, ${rem(10)}, 0);
      ${media.LargeScreenUp`
      transform: scale(1) translate3d(0, ${rem(15)}, 0);
      `}
      width: auto;
      a:hover {
        opacity: 1;
      }
    }

    > a {
      opacity: 1;
      svg {
        path {
          opacity: 1;
        }
      }
    }

    > a:hover {
      color: ${(props) => props.theme.colors.grey};
    }

    .arrow svg {
      transform: scaleY(-1);
    }
  }

  > a {
    color: ${(props) => props.theme.colors.grey_op65};
    transition: opacity 0.3s ${(props) => props.theme.ease.ease_out_expo},
      color 0.3s ${(props) => props.theme.ease.ease_out_expo};
    ${navigationlinkStyle}
  }
`

const Favourites = styled(Grid)`
  position: relative;
  &:hover svg path {
    fill: ${(props) => props.theme.colors.blue};
  }
  svg path {
    transition: fill 0.3s ${(props) => props.theme.ease.ease_out_expo};
  }

  ${media.LargeScreenUp`
  padding-top: 15px;
  padding-bottom: 15px;
  `}
`

const Login = styled(Box)`
  text-align: center;
  > a {
    padding: ${rem(6)};
  }
`

const LoginSmallText = styled(Text)`
  display: block;
  color: ${(props) => props.theme.colors.grey_op65};
  a {
    display: inline;
    font-weight: bold;
    color: ${(props) => props.theme.colors.blue};
  }
`

const Count = withTheme(styled.span`
  color: ${(props) => props.theme.colors.blue};
`)

const Counter = styled(Box)`
  position: absolute;
  top: ${rem(11)};
  right: ${rem(-5)};
  color: white;
  font-size: ${rem(9)};
  font-weight: bold;
  background-color: ${(props) => props.theme.colors.blue};
  padding: ${rem(1)} ${rem(3)} ${rem(2)};
  border-radius: ${rem(3)};
  line-height: 1.3;
`

const IconProfile = styled(IconAccountProfile)`
  path {
    fill: ${(props) => props.theme.colors.blue};
  }
`

export {
  AccountDropDown,
  SubMenu,
  Menu,
  Favourites,
  Login,
  LoginSmallText,
  Count,
  Counter,
  IconProfile
}
